import { Icon, Link, MessageBar, MessageBarType, Persona, PersonaSize, Spinner } from '@fluentui/react';
import { PatientPreferredDoctor } from '../../api';
import { PCP_ENABLED } from '../../config/constants';
import * as React from 'react';
import { ROUTES } from '../../config/routes';
import { AsyncData } from '../../redux/core';
import { toShortDateString } from '../../util/Date';

export interface PreferredDoctorProps {
  preferredDoctor: AsyncData<PatientPreferredDoctor>;
  size?: 'small';
  linkToProfile?: boolean;
}

export class PreferredDoctorPersona extends React.Component<PreferredDoctorProps> {
  public render(): JSX.Element {
    const { preferredDoctor } = this.props;

    if (preferredDoctor.isFetching) {
      return <Spinner />;
    }

    if (preferredDoctor.error) {
      return <MessageBar messageBarType={MessageBarType.error}>{preferredDoctor.error}</MessageBar>;
    }

    if (!preferredDoctor.data) {
      return <div>No Preferred Provider selected</div>;
    }

    const onRenderPreferredDoctorPrimaryText = () => {
      if (this.props.linkToProfile) {
        return (
          <Link href={`${ROUTES.providers}/${preferredDoctor.data!.doctor.providerId}`} style={{ fontSize: this.props.size === 'small' ? 14 : 20 }}>
            {preferredDoctor.data!.doctor.firstName + ' ' + preferredDoctor.data!.doctor.lastName}
          </Link>
        );
      } else {
        return <div>{preferredDoctor.data!.doctor.firstName + ' ' + preferredDoctor.data!.doctor.lastName}</div>;
      }
    };

    const onRenderPreferredDoctorTertiaryText = () => {
      const tertiaryText: JSX.Element[] = [];
      if (PCP_ENABLED.some((status) => status === preferredDoctor.data?.status)) {
        tertiaryText.push(<div key="pcp">Primary Care Provider</div>);
      }
      if (!preferredDoctor.data!.stillValid) {
        tertiaryText.push(
          <div key="pd_invalid" style={{ color: 'red', fontWeight: 600, display: 'flex', marginTop: 5 }}>
            <Icon iconName="Error" style={{ fontSize: 18, marginRight: 5 }} /> No longer available
          </div>
        );
      }
      return tertiaryText.length > 0 ? <div>{tertiaryText}</div> : null;
    };

    return (
      <div>
        <Persona
          size={this.props.size === 'small' ? PersonaSize.size48 : PersonaSize.size72}
          imageUrl={preferredDoctor.data.doctor.avatarUrl}
          onRenderPrimaryText={onRenderPreferredDoctorPrimaryText}
          secondaryText={`Since: ${toShortDateString(new Date(preferredDoctor.data.since))}`}
          onRenderTertiaryText={onRenderPreferredDoctorTertiaryText}
        />
        {this.props.size === 'small' && onRenderPreferredDoctorTertiaryText()}
      </div>
    );
  }
}
